import { Alert } from "@merge-api/merge-javascript-shared";
import {
  Connector,
  IntegrationSetupStepType,
  ReportFields,
} from "../../../config/types";
import CardHeader from "../../shared/CardHeader";
import MergeLinkCardBase from "../../shared/MergeLinkCardBase";
import ConnectorSetupStepFormHeader from "./ConnectorSetupStepFormHeader";
import { Inputs } from "./MainConnectorSetupStepBase";
import ConnectorSetupStepForm from "./ConnectorSetupStepForm";
import ConnectorSetupStepFormButtons from "./ConnectorSetupStepFormButtons";

interface Props {
  currentStepType?: IntegrationSetupStepType;
  header?: string;
  subHeader?: string | React.ReactNode | null;
  description: string;
  connector: Connector;
  onExit: () => void;
  navigateToPreviousStep: (() => void) | undefined;
  navigateToNextStep: () => void;
  inputs?: Inputs;
  isStepComplete: boolean;
  allowContinueWithErrors?: boolean;
  reportFields?: ReportFields;
  buttonTextOverride?: string;
  setIsStepComplete?: (isStepComplete: boolean) => void;
  confirmMessage?: string;
  scrollHeight?: number;
  shouldShowHelpCenterButton?: boolean;
  errorMessage?: string;
}

const ConnectorSetupStepBase = ({
  currentStepType,
  connector,
  header,
  subHeader,
  description,
  onExit,
  navigateToPreviousStep,
  navigateToNextStep,
  inputs,
  isStepComplete,
  allowContinueWithErrors,
  reportFields,
  buttonTextOverride,
  setIsStepComplete,
  confirmMessage,
  scrollHeight,
  shouldShowHelpCenterButton,
  errorMessage,
}: Props) => {

  return (
    <MergeLinkCardBase>
      <CardHeader onBack={navigateToPreviousStep} onExit={onExit} />
      <div className="flex flex-col flex-grow justify-start w-full overflow-hidden">
        <ConnectorSetupStepFormHeader
          connector={connector}
          header={header}
          subHeader={subHeader}
          description={description}
          scrollHeight={scrollHeight}
          shouldShowHelpCenterButton={shouldShowHelpCenterButton}
        />
        {/* TODO: replace form-level error handling to field-level */}
        {errorMessage && (
          <div className="px-5 mb-4">
            <Alert color="red">{errorMessage}</Alert>
          </div>
        )}
        <ConnectorSetupStepForm
          currentStepType={currentStepType}
          inputs={inputs}
          reportFields={reportFields}
          setIsStepComplete={setIsStepComplete}
        />
      </div>
      <ConnectorSetupStepFormButtons
        currentStepType={currentStepType}
        inputs={inputs}
        isStepComplete={isStepComplete}
        allowContinueWithErrors={allowContinueWithErrors}
        navigateToNextStep={navigateToNextStep}
        buttonTextOverride={buttonTextOverride}
        setIsStepComplete={setIsStepComplete}
        confirmMessage={confirmMessage}
        shouldShowHelpCenterButton={shouldShowHelpCenterButton}
      />
    </MergeLinkCardBase>
  );
};

export default ConnectorSetupStepBase;
